import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@viewer/core";
import { ImpactLinkService, ImpactLink } from "@viewer/core/toc-items/impact-link.service";
import { IReactionDisposer, reaction } from "mobx";

@Component({
  standalone: false,
  selector: "o-impacting-warning",
  templateUrl: "./impacting-warning.component.html",
  styleUrls: ["./impacting-warning.component.scss"]
})
export class ImpactingWarningComponent implements OnInit, OnDestroy {
  public dmcChangeHandlerReaction: IReactionDisposer;
  public isClose = true;
  public message: string;
  public links: ImpactLink[];

  constructor(
    public store: Store,
    private impactedLinkService: ImpactLinkService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.dmcChangeHandlerReaction = reaction(
      () => [this.store.currentDMC, this.store.offlineSearchReady],
      () => {
        if (!this.store.currentDMC) {
          return;
        }
        this.links = [];
        this.message = this.impactedLinkService.checkImpactedLinkType(this.store.currentDMC)
          ? "linked.datamodule.label"
          : "linked.label";
        this.impactedLinkService
          .getImpactLinks(this.store.currentDMC)
          .then((links: ImpactLink[]) => {
            this.links = links;
          });
      },
      { fireImmediately: true }
    );
  }

  ngOnDestroy() {
    this.dmcChangeHandlerReaction();
  }

  /**
   * Allows you to navigate to the DMC or the search for the clicked link.
   * @param linkId Link to be searched.
   */
  public navigateTo(linkId: string) {
    this.router.navigate(["redirect", linkId], {
      relativeTo: this.route.root.firstChild.firstChild
    });
  }

  public toggle() {
    this.isClose = !this.isClose;
  }
}
